import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicationHttpClient } from '../../../shared/http/application-http-client';
import { Routes } from '../../../../config/routes';
import {
    EntityHistoryQueryParams,
    EntityHistoryResponse,
    EntityHistorySubjectType,
} from './entity-history.types';

@Injectable({ providedIn: 'root' })
export class EntityHistoryService
{
    constructor(private _http: ApplicationHttpClient)
    {
    }

    /**
     * Hits the unified audit-history endpoint:
     *   GET /audit-history/{subjectType}/{subjectId}/paginated
     */
    public getPaginated(
        subjectType: EntityHistorySubjectType,
        subjectId: number,
        params: EntityHistoryQueryParams = {},
    ): Observable<EntityHistoryResponse>
    {
        const queryParams: { [key: string]: any } = {
            page: params.page ?? 1,
            perPage: params.perPage ?? 25,
        };

        if (params.eventTypes?.length) {
            queryParams['eventTypes'] = params.eventTypes;
        }
        if (params.from) {
            queryParams['from'] = params.from;
        }
        if (params.to) {
            queryParams['to'] = params.to;
        }
        if (params.actorId != null) {
            queryParams['actorId'] = params.actorId;
        }

        // SD-9124: chart of accounts records have their own history route, keyed by kind.
        const path = subjectType.startsWith('coa_')
            ? `/audit-history/chart-of-accounts/${ subjectType.slice(4) }/${ subjectId }/paginated`
            : `/audit-history/${ subjectType }/${ subjectId }/paginated`;
        const url = Routes.MakeLegFiCoreUrl(path)
            + this._http.queryStringFromObject(queryParams);

        return this._http.get(url) as Observable<EntityHistoryResponse>;
    }
}
